import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { FvmsApiBaseService } from "./fvms.api.base.service";

@Injectable({providedIn: 'root'})
export class FvmsApiDtgReportCarService extends FvmsApiBaseService {
    constructor(
        public http:HttpClient
    ) {
        super(http);
    }

    //Deprecated
    // getListReportCarSumAll(searchInfo:any):Observable<any>{
    //     let url = this.getApiBaseUrl() + "/dtg/report/car";
    //     url += "/summary/all";

    //     let header = new HttpHeaders({
    //         "Content-Type":"application/json"
    //     });

    //     // searchInfo = {
    //     //     companyId:1
    //     //     ,searchDateFrom:"2019-04-06 00:00:00"
    //     //     ,searchDateTo:"2019-04-06 23:59:59"
    //     // };
    //     let tmpPostObject = {
    //         "searchInfo":searchInfo
    //     };

    //     //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
    //     //때문에 객체를 복사해서 사용
    //     let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

    //     let bodyData = JSON.stringify(tmpData);

    //     return this.http.post<any>(url,bodyData,{ headers : header });
    // }

    //Deprecated
    // getListReportCarChart(searchInfo:any):Observable<any>{
    //     let url = this.getApiBaseUrl() + "/dtg/report/car";
    //     url += "/chart/list";

    //     let header = new HttpHeaders({
    //         "Content-Type":"application/json"
    //     });

    //     // searchInfo = {
    //     //     companyId:1
    //     //     ,dtgUnitId:"01229522504"
    //     //     ,searchDateFrom:"2019-04-06 00:00:00"
    //     //     ,searchDateTo:"2019-04-06 23:59:59"
    //     //     ,dtgGroupByRegDtYy:"Y"//년도별 동시운행차량수
    //     //     ,dtgGroupByRegDtMm:"Y"//월별 동시운행차량수
    //     //     ,dtgGroupByRegDtDd:"Y"//일별 동시운행차량수
    //     //     ,dtgGroupByTripCnt:null//트립별 동시운행차량수
    //     // };
    //     let tmpPostObject = {
    //         "searchInfo":searchInfo
    //     };

    //     //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
    //     //때문에 객체를 복사해서 사용
    //     let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

    //     let bodyData = JSON.stringify(tmpData);

    //     return this.http.post<any>(url,bodyData,{ headers : header });
    // }

    //차량별운행일지 목록
    getListReportCar(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/report/car";
        url += "/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     companyId:1
        //     ,dtgEid:"2288100534"
        //     ,searchDateFrom:"2019-04-06 00:00:00"
        //     ,searchDateTo:"2019-04-06 23:59:59"
        //     ,dtgCarType:"11"
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getListReportCarDetailInTrip(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/report/car";
        url += "/detail/inTrip/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    //차량별운행일지 상세
    getListReportCarDetailTrip(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/report/car";
        url += "/detail/trip/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    // 온도일지 상세
    getListReportCarDetailNoTrip(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/report/car";
        url += "/detail/noTrip/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

}